<template>
	<div>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<v-alert icon="mdi-email-fast" prominent text dark color="warning">
				<div v-if="localData">
					<div style="border-bottom: 1px dashed #ffd29d;" class="pb-2 mb-2">
						{{ localData.title }}
					</div>
					<div class="d-flex justify-space-between">
						<div class="text-right">شماره تیکت: {{ localData.code }}</div>
						<div class="text-center">وضعیت تیکت: {{ localData.status_Str }}</div>
						<div class="text-left">
							<v-btn v-if="localData.status != 3" :loading="closeTicketLoading" small elevation="0" color="red" @click="closeTicket">
								مختومه کردن (بستن) تیکت
							</v-btn>
						</div>
					</div>
				</div>
				<div v-else>
					جهت ارسال تیکت، فرم زیر را پر کرده و بر روی دکمه "ارسال" کلیک کنید.
				</div>
			</v-alert>

			<div v-if="step === 'submit'">
				<div v-if="localData">
					<v-card v-for="(response, index) in localData.ticketResponses" :key="response.id + index" class="mb-8" elevation="0" color="#eee">
						<v-card-actions style="border-bottom: 1px dashed #ccc;display: block;">
							<div>
								<span>ثبت پیام توسط:</span>
								<span class="mr-1 grey--text">{{ response.createdBy }} ({{ response.role_Str }})</span>
							</div>
							<div>
								<span>تاریخ ثبت:</span>
								<span class="mr-1 grey--text">&lrm;{{ response.createdAt_Persian.date }} {{ response.createdAt_Persian.time }}</span>
							</div>
						</v-card-actions>
						<v-card-text>
							<v-row>
								<v-col cols="12" md="12">
									<div style="white-space: pre-line; border-bottom: 1px dashed #ddd;" class="py-3">
										{{ response.description }}
									</div>
								</v-col>
								<v-col cols="12" md="12" class="pa-3 text-center">
									فایل پیوست:
									<span v-if="!response.fileName">ندارد</span>
									<ImageUploader v-else :editable="false" :options="{ image: { width: 75 } }" :ref="'imageUploader' + response.id + index" :downloadFileName="`پیوست مربوط به تیکت ${localData.code}`" v-model="response.base64" :fileUrl="response.fileUrl" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(response.base64)" @delete="() => response.fileName = ''" />
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</div>

				<v-card class="mb-8" elevation="0" color="#fff">
					<v-form ref="form" class="mx-2" lazy-validation>
						<v-card-text>
							<v-row>
								<!-- <v-col cols="12" md="3" class="pa-3 text-center">
								<ImageUploader :ref="'imageUploaderNew'" :editable="true" v-model="ticketResponse.base64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(ticketResponse.base64)" @delete="() => ticketResponse.fileName = ''" />
							</v-col> -->
								<v-col cols="12" md="12" class="py-1">
									<TicketTargetTypeSelector ref="ticketTargetTypeSelector" v-if="!localData && userType === 'admin'" />
									<v-text-field dense v-if="!localData" v-model="ticketResponse.title" outlined :label="'عنوان تیکت را وارد کنید'" :error-messages="errorMessages" :rules="[(val) => !!val || 'عنوان را وارد کنید']" />
									<div v-else class="fs-h3" style="font-size: 1.1rem;">
										پیام جدید ارسال کنید:
									</div>
								</v-col>
								<v-col cols="12" md="12" class="py-1">
									<v-textarea v-model="ticketResponse.description" outlined :error-messages="errorMessages" label="شرح" hint="حداکثر 1500 کاراکتر" :rules="[(val) => !!val || 'شرح تیکت را وارد کنید']" />
								</v-col>
								<v-col cols="12" sm="8" class="py-1">
									<v-file-input ref="file" v-model="file" :accept="'.jpg,.jpeg,.png,.pdf,.xlsx,.xls'" placeholder="" prepend-icon="mdi-file-outline" label="جهت پیوست کردن فایل، اینجا را کلیک کنید" />
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions>
							<v-spacer />
							<v-btn :loading="submitLoading" @click="save()" color="primary" dark>
								ارسال
							</v-btn>
							<v-spacer />
						</v-card-actions>
					</v-form>
				</v-card>
			</div>

			<div v-if="step === 'success'" class="d-flex flex-column align-center justify-center">
				<v-btn fab color="success" elevation="1">
					<v-icon color="white">mdi-email-check</v-icon>
				</v-btn>
				<div class="success--text text-center mt-4" style="font-size: 1.3rem;">
					تیکت با موفقیت ثبت شد.
					<div style="font-size: 0.9rem;" class="mt-2">
						{{ msg }}
					</div>
				</div>
			</div>
		</div>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import ImageUploader from '@/components/uploader/ImageUploader'

	export default {
		name: 'ModifyTicket',
		props: {
			ticketId: { type: String },
			userType: { type: String }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			TicketTargetTypeSelector: () => import('./TicketTargetTypeSelector'),
			ImageUploader,
		},
		data() {
			return {
				emptyId: emptyId,
				step: 'submit',
				file: null,
				msg: '',
				overlayImgSrc: '',
				overlay: false,
				errorMessages: '',
				ticketResponse: {},
				localData: null,
				submitLoading: false,
				loading: false,
				closeTicketLoading: false
			}
		},
		computed: {

		},
		mounted() {
			if (this.ticketId) {
				this.loadData()
			}
		},
		methods: {
			loadData() {
				this.loading = true
				api.get(`${this.userType}/Ticket/Get/` + this.ticketId, null)
					.then(response => {
						this.localData = response
					})
					.catch(err => {
						this.localData = null
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			save() {
				if (!this.$refs.form.validate()) { return }
				const formData = new FormData()
				if (this.file) {
					formData.append('file', this.file)
				}
				formData.append('description', this.ticketResponse.description)
				formData.append('title', this.ticketResponse.title)
				formData.append('ticketId', this.localData?.id)
				if (this.$refs.ticketTargetTypeSelector) {
					let targetType = this.$refs.ticketTargetTypeSelector.commitData()
					let error = false
					if (!(targetType?.targetType > 0))
						error = true

					if ((targetType?.targetType === 3 || targetType?.targetType === 5) && !targetType.userIds?.length)
						error = true

					if (error) {
						toast.error('هیچ مخاطبی انتخاب نشده است.')
						return
					}

					if (targetType) {
						formData.append('createTicketTarget', targetType.targetType)
						for (var i = 0; i < targetType.userIds.length; i++) {
							formData.append('userIds[]', targetType.userIds[i])
						}
					}
				}
				this.submitLoading = true
				const url = this.localData ? `${this.userType}/ticketresponse/create` : `${this.userType}/ticket/create`
				api.post(url, formData, { contentType: 'multipart/form-data' })
					.then(response => {
						if (!this.localData) {
							if (this.userType === 'admin')
								this.msg = `تعداد تیکت ایجاد شده: ${response}`
							else {
								this.msg = `شماره تیکت: ${response}`
								this.localData = { code: response, title: this.ticketResponse.title, status_Str: 'در انتطار بررسی' }
							}
						}
						this.step = 'success'
						this.$emit('callbck', 'refresh')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			viewImage(img) {
				this.overlay = true
				this.overlayImgSrc = img
			},
			async closeTicket() {
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از مختومه کردن تیکت مطمئن هستید؟',
				)) {
					this.closeTicketLoading = true
					let data = {
						status: 3,
						ticketId: this.localData.id
					}
					api.post(`${this.userType}/Ticket/ChangeStatus`, data)
						.then(response => {
							toast.success('تیکت با موفقیت بسته شد.')
							this.$emit('callbck', 'refresh')
							this.localData.status = 3
							this.localData.status_Str = 'بسته شده'
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => {
							this.closeTicketLoading = false
						})
				}
			}
		},
	}
</script>
<style></style>
